import { useEffect, useState } from 'react';
import { Input } from '../..//common/Forms/Input/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../..//assets/schemas/schemas';
import { ActionButton } from '../..//common/Buttons/Buttons';
import {
  paymentType,
  planStatus,
  planTypes,
} from '../../..//assets/helpers/options';
import { usersService } from '../../..//services/usersService';
import { saleChannelService } from '../../..//services/saleChannelService';
import { membershipService } from '../../..//services/membershipService';
import { papService } from '../../..//services/papService';
import { membershipCatalogService } from '../../..//services/membershipCatalogService';
import { currencyRateService } from '../../..//services/currencyRateService';
import { notify } from '../../..//assets/helpers/toast';
import {
  filterParams,
  getCorrectDate,
  displayMembershipCode,
} from '../../..//assets/helpers/funciones';
import { LoadSpinner } from '../..//common/LoadSpinner/LoadSpinner';
import { OderCardHeader } from '../../views/AffiliationsDB/Order/OrderComponents';
import authService from '../../..//services/authService';
import { salesRoles } from '../../..//assets/helpers/roles';
import moment from 'moment';
import { useHistory } from 'react-router-dom';



export const PAPAfiliationCard = (props) => {
  const { label, membership, reloadMembership } = props;
  const [open, setOpen] = useState(true);
  const [salesChannelOptions, setSalesChannelOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [membershipOptions, setMembershipOptions] = useState([]);
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
  } = useForm({
    resolver: yupResolver(schemas.updateMembershipForm()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    watch: watch2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.PAPAfilationDateForm()),
  });

  const preloadForm = () => {
    // DATOS DEL PLAN
    setValue('affiliationType', membership?.affiliationType);
    setValue('saleChannel', membership?.saleChannel?._id);

    setValue('contractType', membership?.contractType);
    setValue('campaignAction', membership?.campaignAction);
    // FECHAS ASOCIADAS
    setValue2(
      'createdAt',
      membership?.creationDate ? getCorrectDate(membership?.creationDate) : ''
    );
    setValue2(
      'startDate',
      membership?.startDate ? getCorrectDate(membership?.startDate) : ''
    );
    setValue2(
      'endDate',
      membership?.endDate ? getCorrectDate(membership?.endDate) : ''
    );
  };



  const getAvailableMemberships = () => {
    let params = {};

    params.landing = 'Pap'
    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then((response) => {
        if (response.status === 200) {

          let data = []
          for (let i = 0; i < response?.data?.length; i++) {
            data.push({
              _id: response?.data[i]?._id,
              name: displayMembershipCode(response?.data[i]?.code)
            })
          }

          setMembershipOptions(data);
          setValue('plan', membership?.plan);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  function dateDiffInDays(firstDate, secondDate) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const diffDays = Math.round(
      Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
    );
    return diffDays;
  }

  const validateCreatedDate = (dataToPost) => {
    const firstDate = new Date();
    const secondDate = new Date(dataToPost?.createdAt);
    const daysDifference = dateDiffInDays(firstDate, secondDate);

    if (
      [
        salesRoles?.SALES_SUPERVISOR,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      daysDifference > 5
    ) {
      delete dataToPost?.createdAt;
      return dataToPost;
    } else return dataToPost;
  };

  const editMembership = handleSubmit2(async (data) => {
    let dataToPost = { ...data };

    dataToPost.createdAt = dataToPost?.createdAt
      ? moment(dataToPost?.createdAt).format('YYYY-MM-DD')
      : ""
    dataToPost.startDate = dataToPost?.startDate
      ? moment(dataToPost?.startDate).format('YYYY-MM-DD')
      : ""
    dataToPost.endDate = dataToPost?.endDate
      ? moment(dataToPost?.endDate).format('YYYY-MM-DD')
      : "";

    dataToPost = validateCreatedDate(dataToPost);
    // delete dataToPost?.createdAt;
    delete dataToPost?.contractType;
    delete dataToPost?.affiliationType;
    dataToPost = filterParams(dataToPost);

    if (!isLoading) {
      setIsLoading(true);
      papService
        .updatePAPAffiliation(dataToPost, membership?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Datos actualizados`, 'success');
            reloadMembership();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });


  const getUsers = async () => {
    let params = {
      limit: 1000000,
      offset: 0,
      module: 'Ventas',
      status: 'Activo',
    };
    usersService
      .getUsers(params)
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          for (let i = 0; i < response?.data?.users?.length; i++) {
            data?.push({
              _id: response?.data?.users[i]?._id,
              name:
                response?.data?.users[i]?.firstName +
                '  ' +
                response?.data?.users[i]?.lastName,
            });
          }

          setValue('seller', membership?.seller);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const getSalesChannel = () => {
    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if (response.status === 200) {
          setSalesChannelOptions(response?.data?.saleChannels);
          setValue('saleChannel', membership?.saleChannel?._id);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };


  const updateStatus = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updateMembershipStatus(membership?._id)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            // notify(`Membresia aprobada`, 'success');
            window.location.reload();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const updatePaymentTypeInRenewal = () => {
    if (!isLoading) {
      setIsLoading(true);
      membershipService
        .updatePaymentTypeInRenewal(membership?._id, {
          paymentType: watch2('paymentType'),
        })
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            setIsLoading(false);
            reloadMembership();
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const changePaymentType = () => {
    if (
      [
        planStatus.PENDING_FOR_APPROBAL,
        planStatus.WAITING,
        planStatus.TO_BE_EXPIRED,
      ].includes(membership.membershipStatus)
    ) {
      history.push(
        `/afiliations/change-payment/${membership?._id}/${watch2('paymentType')
          .replace(/ /g, '-')
          .toLowerCase()}`
      );
    } else {
      if (watch2('paymentType') === paymentType?.FINANCIADO) {
        setValue2('paymentMethodsQuantity', 1);
      }

      updatePaymentTypeInRenewal();
    }
  };


  useEffect(() => {
    getAvailableMemberships();
    getSalesChannel();
    preloadForm();
  }, [open, membership]);

  const validateDisabled = (inputName) => {
    if (
      ['rcvBeginDate', 'rcvEndDate']?.includes(inputName) &&
      membership?.membershipPlan === planTypes?.PLUSF4
    ) {
      return true;
    }

    if (
      [
        salesRoles.SALES_ADMIN,
        salesRoles?.SALES_DEVELOPER,
        salesRoles?.SALES_SUPERVISOR,
      ].includes(authService.getUserType())
    ) {
      return false;
    }
    if (
      [salesRoles.SALES_ADMIN_AUX].includes(authService.getUserType()) &&
      membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL
    ) {
      return false;
    }
    if (
      [
        salesRoles?.SALES_SUPERVISOR,
        salesRoles.SALES_HUNTER,
        salesRoles.SALES_FARMER,
        salesRoles.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      [planStatus?.PENDING_FOR_APPROBAL, planStatus?.TO_BE_RENEW].includes(
        membership?.membershipStatus
      )
    ) {
      return false;
    } else return true;
  };

  const determinValidDate = () => {
    // let createdAt = new Date(watch('createdAt'));
    let createdAt = new Date();
    let minDate = createdAt;
    minDate.setDate(minDate.getDate() - 4);

    if ([salesRoles?.SALES_ADMIN].includes(authService.getUserType())) {
      return false;
    }
    if (
      [
        salesRoles?.SALES_SUPERVISOR,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL
    ) {
      return minDate;
    } else return false;
  };

  const validateCreationDate = () => {
    if ([salesRoles?.SALES_ADMIN].includes(authService.getUserType())) {
      return false;
    }

    if (
      [
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(
        authService.getUserType() &&
        [planStatus?.ACTIVE, planStatus?.TO_BE_RENEW]?.includes(
          membership?.membershipStatus
        )
      )
    ) {
      return true;
    }

    if (
      [
        salesRoles.SALES_ADMIN_AUX,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ].includes(authService.getUserType()) &&
      membership?.membershipStatus === planStatus?.PENDING_FOR_APPROBAL
    ) {
      return false;
    } else return true;
  };




  const validatePlanType = (membershipStatus) => {
    if ([salesRoles.SALES_ADMIN].includes(authService?.getUserType())) {
      return false;
    }
    if (![planStatus?.PENDING_FOR_APPROBAL].includes(membershipStatus)) {
      return true;
    } else return false;
  };

  const getCurrencyRates = () => {
    let createdAt = getCorrectDate(membership?.createdAt);
    let date1 = moment(createdAt).format('YYYY-MM-DD');
    let date2 = moment(watch('createdAt')).format('YYYY-MM-DD');

    if (date1 !== date2) {
      let params = {
        currency: 'USD',
        date: watch('createdAt')
          ? moment(watch('createdAt')).format('YYYY-MM-DD')
          : '',
        limit: 1,
      };

      currencyRateService
        .getCurrencyRates(params)
        .then((response) => {
          if (response.status === 200) {
            let rate = response?.data?.result[0]?.rate;
            // editAllPaymentBs(rate);
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => { });
      return true;
    }
  };


  // Internal counter cant see affiliation cards
  // if (
  //   [salesRoles?.SALES_COUNTER].includes(authService?.getUserType()) &&
  //   membership?.membershipStatus === planStatus?.INCOMPLETED &&
  //   authService?.getUser()?.type === userType?.INTERNO
  // ) {
  //   return null;
  // }

  // Admin Aux cant see affiliation card
  if (
    [salesRoles?.SALES_ADMIN_AUX].includes(authService?.getUserType()) &&
    membership?.membershipStatus === planStatus?.INCOMPLETED
  ) {
    return null;
  }

  return (
    <>
      <LoadSpinner show={isLoading} />

      <div className="order-card">
        <OderCardHeader open={open} setOpen={setOpen} label={label} />

        {open && (
          <>
            <br />
            <div style={{ width: '100%', }} className="row">
              <div className="col-12 col-md-4">
                <div className="buttons-container">
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    DATOS DEL PLAN
                  </h6>
                </div>
                <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>

                <div className="row">
                  <Input
                    bootstrap={'col-12'}
                    label={'Tipo de afiliación '}
                    type={'text'}
                    name={'affiliationType'}
                    register={register}
                    placeholder={''}
                    errors={errors?.affiliationType?.message}
                    disabled={true}
                  />{' '}
                  <Input
                    bootstrap={'col-12'}
                    label={'Canal '}
                    type={'select'}
                    name={'saleChannel'}
                    options={salesChannelOptions}
                    register={register}
                    placeholder={''}
                    errors={errors?.saleChannel?.message}
                  />{' '}
                  <Input
                    bootstrap={'col-12'}
                    label={'Tipo de Plan '}
                    type={'select'}
                    name={'plan'}
                    options={membershipOptions}
                    register={register}
                    placeholder={''}
                    errors={errors?.plan?.message}
                    disabled={validatePlanType(membership?.membershipStatus)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="buttons-container">
                  <h6 style={{ margin: '6px 12px 12px 0px' }}>
                    FECHAS ASOCIADAS
                  </h6>
                  <ActionButton label={'Guardar'} action={editMembership} />
                </div>
                <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>

                <div className="row">
                  <Input
                    bootstrap={'col-12'}
                    label={'Fecha de creación'}
                    type={'date'}
                    name={'createdAt'}
                    register={register2}
                    placeholder={''}
                    control={control2}
                    errors={errors2?.createdAt?.message}
                    disabled={validateCreationDate()}
                    minDate={determinValidDate()}
                    onChange={() => console.log("")}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Inicio del Plan'}
                    type={'date'}
                    name={'startDate'}
                    register={register2}
                    placeholder={''}
                    control={control2}
                    errors={errors2?.startDate?.message}
                    disabled={validateDisabled()}
                    onChange={() => console.log("")}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Fin del Plan'}
                    type={'date'}
                    name={'endDate'}
                    register={register2}
                    placeholder={''}
                    control={control2}
                    errors={errors2?.endDate?.message}
                    disabled={validateDisabled()}
                    onChange={() => console.log("")}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div style={{ marginBottom: "64px" }} ></div>
    </>
  );
};

